<template>
  <el-input
    :value="value"
    type="textarea"
    autosize
    disabled
    placeholder="该项需要在小程序中操作获取"
  ></el-input>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
};
</script>

<style lang="scss" scoped></style>
